function hash32(value){
  let hash=0x811c9dc5;
  for(const char of String(value||'')){hash^=char.codePointAt(0);hash=Math.imul(hash,0x01000193);}
  return hash>>>0;
}
export function createReminderNamespace({source,min,size,keyLabel='reminder key'}={}){
  if(typeof source!=='string'||!source.trim())throw new TypeError('source is required');
  if(!Number.isSafeInteger(min)||min<1||!Number.isSafeInteger(size)||size<1||!Number.isSafeInteger(min+size))throw new TypeError('Invalid reminder ID range');
  return Object.freeze({
    id(key){const value=String(key||'').trim();if(!value)throw new TypeError(keyLabel+' is required');return min+(hash32(value)%size);},
    owns(notification){return notification?.extra?.source===source||(Number.isInteger(Number(notification?.id))&&Number(notification.id)>=min&&Number(notification.id)<min+size);},
    range:Object.freeze({min,maxExclusive:min+size})
  });
}
